import type { HighlightProps } from './Highlight.typed';
import * as Styled from './Highlight.styled';

const Highlight = ({ color = 'GREY_DARKER', children }: HighlightProps) => (
  <Styled.Highlight color={color}>
    <Styled.Badge color={color}>{children}</Styled.Badge>
  </Styled.Highlight>
);
export { Highlight };
